import React from 'react';

interface PaymentSuccessModalProps {
    show: boolean;
    onClose: () => void;
}

const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/60 z-[260] backdrop-blur-xs flex items-center justify-center p-4 text-left">
            <div className="bg-[#4a4a4a] text-white rounded-lg p-6 max-w-md w-full shadow-2xl">
                <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Comic Sans MS, Comic Sans, cursive' }}>Success</h3>
                <p className="text-gray-100 text-base leading-relaxed mb-8">Payment completed! Your items will be available for pickup.</p>
                <div className="flex justify-end">
                    <button type="button" onClick={onClose} className="text-cyan-300 hover:text-cyan-200 font-medium text-lg transition-colors">OK</button>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccessModal;
